import React from "react";
import Contents from "../layout/Contents";
import ContTitle from "../layout/ContTitle";
import PortText from "../port/PortText";

const PortPage = () => {
  return (
    <Contents>
      <ContTitle title="gallery" />
      <PortText />
    </Contents>
  );
};

export default PortPage;
